import { Alert, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { formatUtcToLocal } from '../utils/dateUtils';

export default function EmergencyClearanceReview({ review, onRefresh, busy = false }) {
  const alerts = review.confirmation?.alerts || [];
  return <Stack spacing={1}>
    {review.loading && <Stack direction="row" spacing={1} alignItems="center">
      <CircularProgress size={18}/><Typography role="status">Loading current emergency alerts...</Typography>
    </Stack>}
    {review.error && <Alert severity="warning">{review.error}</Alert>}
    {!review.loading && review.confirmation && alerts.length === 0 && <Alert severity="info">No active emergency alerts were found.</Alert>}
    {alerts.map(alert => <Alert key={alert.cycleId} severity="warning" sx={{ overflowWrap: 'anywhere' }}>
      <Typography fontWeight={700}>{alert.rangerId || alert.name || 'Emergency alert'}</Typography>
      <Typography variant="body2">Activated {formatUtcToLocal(alert.activatedAtUtc)}</Typography>
      {alert.location && <Typography variant="body2">{alert.location}</Typography>}
    </Alert>)}
    <Button onClick={onRefresh} disabled={busy || review.loading}>Refresh alerts to review</Button>
  </Stack>;
}
